import { fetchApi } from "../DataApi/fetchApi";

export async function publishOnWebsite(prodId) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      id: prodId,
      object: "product.template",
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({
    requestOptions,
    endpoint: `/website/publish`,
  });
}
